import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import _ from 'underscore'
import STATUS_CODE from '../constant/status_code'

const emptyListData = {
  list: []
}
const getColleaguesBuyShareInfo = (data) => {
  return new Promise((resolve, reject) => {

    let query = ''
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`
    }
    let url = `${CONSTANT.REQUEST_HOST}${query}`
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/community/group-info'
    Api.get(url, {
      headers: {
        'X-Host': 'mall.community.group-info',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      }
    })
      .then((data) => {
        if (data.status == STATUS_CODE.EMPTY_LIST) {
          return resolve(data)
        }
        else if (data.status !== 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      },
        (e) => {
          reject(e)
        })
  })
}

const getColleaguesBuyProductList = (data) => {
  return new Promise((resolve, reject) => {

    let query = ''
    if (!_.isEmpty(data)) {
      query = `?${qs.stringify(data)}`
    }
    let url = `${CONSTANT.REQUEST_HOST}${query}`
    // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/community/recommend-product-list'
    Api.get(url, {
      headers: {
        'X-Host': 'mall.community.recommend-product-list',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      }
    })
      .then((data) => {
        if (data.status == STATUS_CODE.EMPTY_LIST) {
          return resolve(data)
        }
        else if (data.status !== 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      },
        (e) => {
          reject(e)
        })
  })
}

const getCommunityList = () => {
  return new Promise((resolve, reject) => {
    let url = `${CONSTANT.REQUEST_HOST}`
    Api.get(url, {
      headers: {
        'X-host': 'mall.community.list',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then((data) => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyListData)
      }
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
  })
}


export default {
  getColleaguesBuyShareInfo,
  getColleaguesBuyProductList,
  getCommunityList
}